module.exports = __webpack_public_path__ + "static/media/link_warning.799451e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/link_warning.svg
// module id = 132
// module chunks = 0